import React, { useState, useEffect } from "react";
import Header from "../../components/Header";
import ModalConfirmLogout from "../../components/ModalConfirmLogout";
import { useNavigate } from "react-router-dom";
import "./CongThucPage.css";
import axios from "axios";
import Swal from "sweetalert2";
import BackgroundVideo from "components/BackgroundVideo";
const Cookies = require("js-cookie");

const RecipeList: React.FC = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [isShowLogout, setIsShowLogout] = useState(false);
  const [selectedFormula, setSelectedFormula] = useState<{
    id: number;
    name: string;
  } | null>(null);
  const [userCoins, setUserCoins] = useState(0);
  const token = Cookies.get("access_token");

  useEffect(() => {
    const userInfoRaw = localStorage.getItem("user_info");
    if (userInfoRaw) {
      try {
        const userInfo = JSON.parse(userInfoRaw);
        setUserCoins(userInfo.coins || 0);
        console.log("User coins from localStorage:", userInfo.coins);
      } catch (error) {
        console.error("Error parsing user info:", error);
      }
    }
  }, []);

  const formulas = [
    { id: 1, name: "VIP 1" },
    { id: 2, name: "VIP 2" },
    { id: 3, name: "VIP 3" },
    { id: 4, name: "VIP 4" },
    { id: 5, name: "VIP 5" },
    { id: 6, name: "VIP 6" },
    { id: 7, name: "VIP 7" },
    { id: 8, name: "VIP 8" },
    { id: 9, name: "VIP 9" },
  ];

  const handleFormulaClick = (formula: { id: number; name: string }) => {
    // Tất cả đều hiển thị modal xác nhận
    setSelectedFormula(formula);
    setShowModal(true);
  };

  const getFormulaText = (id: number) => {
    switch (id) {
      case 1:
        return "THỦ THUẬT LV1: MIỄN PHÍ";
      case 2:
        return "THỦ THUẬT LV2: 200 XU";
      case 3:
        return "THỦ THUẬT LV3: 300 XU";
      case 4:
        return "THỦ THUẬT LV4: 400 XU";
      case 5:
        return "THỦ THUẬT LV5: 500 XU";
      case 6:
        return "THỦ THUẬT LV6: 600 XU";
      case 7:
        return "THỦ THUẬT LV7: 700 XU";
      case 8:
        return "THỦ THUẬT LV8: 800 XU";
      case 9:
        return "THỦ THUẬT LV9: 900 XU";
      default:
        return "THỦ THUẬT LV1: MIỄN PHÍ";
    }
  };

  const getFormulaCost = (id: number) => {
    switch (id) {
      case 1:
        return 0; // MIỄN PHÍ
      case 2:
        return 200;
      case 3:
        return 300;
      case 4:
        return 400;
      case 5:
        return 500;
      case 6:
        return 600;
      case 7:
        return 700;
      case 8:
        return 800;
      case 9:
        return 900;
      default:
        return 0;
    }
  };

  const handleConfirm = async () => {
    if (!selectedFormula) return;

    const cost = getFormulaCost(selectedFormula.id);

    // Nếu miễn phí thì đi thẳng
    if (cost === 0) {
      setShowModal(false);
      navigate(`/cong-thuc/${selectedFormula.id}`);
      return;
    }

    // Kiểm tra token trước
    if (!token) {
      showErrorModal("Bạn cần đăng nhập để mua công thức");
      return;
    }

    // Kiểm tra đủ xu không
    if (userCoins < cost) {
      showErrorModal("Bạn không đủ xu, vui lòng nạp thêm hoặc liên hệ admin");
      return;
    }

    try {
      console.log("Calling API with:", {
        amount: cost,
        action: "PLAY_GAME",
      });

      // Gọi API trừ xu
      const response = await axios.post(
        `${process.env.REACT_APP_URL_API}/users/subtract-coins-for-action`,
        {
          amount: cost,
          action: "PLAY_GAME", // Sử dụng action giống như LobbyRoom
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      // Cập nhật số xu
      setUserCoins(response.data.coins);

      // Cập nhật localStorage
      const userInfoRaw = localStorage.getItem("user_info");
      if (userInfoRaw) {
        const userInfo = JSON.parse(userInfoRaw);
        userInfo.coins = response.data.coins;
        localStorage.setItem("user_info", JSON.stringify(userInfo));
      }

      // Hiển thị thông báo thành công
      Swal.fire({
        icon: "success",
        title: "Thành công!",
        text: `Đã mua ${selectedFormula.name} với giá ${cost} xu`,
        customClass: {
          popup: "bg-custom-image text-white",
        },
      });

      setShowModal(false);

      // Chuyển đến trang chi tiết công thức
      navigate(`/cong-thuc/${selectedFormula.id}`);
    } catch (error: any) {
      console.error("Error purchasing formula:", error);
      console.error("Error response:", error.response?.data);
      console.error("Error status:", error.response?.status);

      // Kiểm tra loại lỗi
      if (error.response?.status === 401) {
        showErrorModal("Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại");
      } else if (error.response?.status === 400) {
        showErrorModal("Bạn không đủ xu, vui lòng nạp thêm hoặc liên hệ admin");
      } else {
        showErrorModal("Có lỗi xảy ra, vui lòng thử lại sau");
      }
    }
  };

  const showErrorModal = (message: string) => {
    Swal.fire({
      icon: "error",
      title: "Lỗi!",
      text: message,
      confirmButtonText: "OK",
      customClass: {
        popup:
          "bg-gradient-to-br from-red-900 to-red-800 text-white border-2 border-red-400",
        confirmButton:
          "bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-lg",
      },
    });
  };

  return (
    <div className="cong-thuc-page">
      <BackgroundVideo />
      <Header setIsShowLogout={() => setIsShowLogout(true)} />
      <div className="md:py-14 py-8" />
      <div className="cong-thuc-content">
        {/* Logo lớn giống header */}
        <div className="cong-thuc-logo">
          <img src="/assets/toolbcrf1.png" alt="Logo" className="main-logo" />
        </div>

        {/* Nút back */}
        <div className="back-button-container">
          <img
            src="/assets/back.png"
            alt="Back"
            className="back-button"
            onClick={() => navigate(-1)}
          />
        </div>

        {/* Grid 9 công thức */}
        <div className="formulas-grid">
          {formulas.map((formula) => (
            <div
              key={formula.id}
              className="formula-item"
              onClick={() => handleFormulaClick(formula)}
            >
              <img
                src={`/assets/vip${formula.id}.png`}
                alt={`Công thức ${formula.name}`}
                className="formula-image"
              />
            </div>
          ))}
        </div>
      </div>

      {/* Modal */}
      {showModal && selectedFormula && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-icon">
              <img
                src="/assets/question.png"
                alt="Question"
                className="question-icon"
              />
            </div>

            {/* Title XÁC NHẬN */}
            <div className="modal-title">XÁC NHẬN</div>

            {/* Text thủ thuật */}
            <div className="modal-text">
              {getFormulaText(selectedFormula.id)}
            </div>

            {/* Buttons accept và cancel */}
            <div className="modal-buttons">
              <img
                src="/assets/accept.png"
                alt="Accept"
                className="modal-button accept-button"
                onClick={handleConfirm}
              />
              <img
                src="/assets/cancel.png"
                alt="Cancel"
                className="modal-button cancel-button"
                onClick={() => setShowModal(false)}
              />
            </div>
          </div>
        </div>
      )}

      <ModalConfirmLogout
        isShowLogout={isShowLogout}
        setIsShowLogout={() => setIsShowLogout(false)}
      />
    </div>
  );
};

export default RecipeList;
